import { sync } from '../../src/components/App/Viewer/sync';
import RotateTool from '../customTools/RotateTool';

class CornerstoneToolsUtils {
  static configuration = {
    TextMarker: {
      markers: ['F5', 'F4', 'F3', 'F2', 'F1'],
      current: 'F5',
      ascending: true,
      loop: true,
    },
    Zoom: {
      invert: true,
      preventZoomOutsideImage: false,
      minScale: 0.1,
      maxScale: 20.0,
    },
  };

  static selectCornerstoneTool(tool) {
    const theTool = `${tool}Tool`;
    const ApiTool = tool === 'Rotate' ? RotateTool : window.cornerstoneTools[theTool];

    // Add tool if is not already added
    if (!this.checkAddedTool(ApiTool)) {
      if (CornerstoneToolsUtils.configuration[tool] === undefined) {
        window.cornerstoneTools.addTool(ApiTool);
      } else {
        window.cornerstoneTools.addTool(ApiTool, {
          configuration: CornerstoneToolsUtils.configuration[tool],
        });
      }
    }

    window.cornerstoneTools.setToolActive(tool, { mouseButtonMask: 1 });
  }

  static checkAddedTool(ApiTool) {
    let added = false;
    window.cornerstoneTools.store.state.tools.forEach((cornerstoneTool) => {
      if (`${cornerstoneTool.name}Tool` === ApiTool.name) {
        added = true;
      }
    });

    return added;
  }

  static getCornerstoneTool(toolName) {
    const findedTool = window.cornerstoneTools.store.state.tools.filter((tool) => tool.name === toolName);
    return findedTool.length > 0 && findedTool[0];
  }
}

export default CornerstoneToolsUtils;
